import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export class RequiredIndicatorComponent {
    _required = false;
    _inverted = false;
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    get inverted() {
        return this._inverted;
    }
    set inverted(value) {
        this._inverted = typeof value !== 'undefined' && value !== false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequiredIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: RequiredIndicatorComponent, selector: "mhe-required-indicator", inputs: { required: "required", inverted: "inverted" }, ngImport: i0, template: "<span *ngIf=\"required\" class=\"required\" [class.inverted]=\"inverted\"> *</span>\n", styles: ["\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequiredIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mhe-required-indicator', template: "<span *ngIf=\"required\" class=\"required\" [class.inverted]=\"inverted\"> *</span>\n", styles: ["/*# sourceMappingURL=required-indicator.component.css.map */\n"] }]
        }], propDecorators: { required: [{
                type: Input
            }], inverted: [{
                type: Input
            }] } });
